import { gql, useMutation } from '@apollo/client'

export const USER_PASSWORD_UPDATE = gql`
  mutation UserPasswordUpdate(
    $password: String!
    $passwordConfirmation: String!
  ) {
    userPasswordUpdate(
      input: {
        password: $password
        passwordConfirmation: $passwordConfirmation
        clientMutationId: "user-password-update"
      }
    ) {
      user {
        id
      }
      errors
    }
  }
`

interface IUserPasswordUpdateResult {
  userPasswordUpdate: {
    user: { id: number } | null
    errors: string[]
  }
}

interface IUserPasswordUpdateInput {
  password: string
  passwordConfirmation: string
}

export const useUserPasswordUpdate = () => {
  const [updatePassword, { loading, error }] =
    useMutation<IUserPasswordUpdateResult>(USER_PASSWORD_UPDATE)

  const handleUpdatePassword = async (input: IUserPasswordUpdateInput) => {
    const response = await updatePassword({ variables: input })
    return response.data?.userPasswordUpdate
  }

  return { handleUpdatePassword, loading, error }
}
